/**
* reducers for the referral process
*
* Created by Paul on 05/02/19
*/

import C from '../constants'

const initState = {
    isEmailing: false,
    response: ''
}

export const referralState = (state = initState, action) => {

    switch(action.type) {

    	case C.SET_REFERRAL_LOADER:
            return {
                ...state,
                isEmailing: action.payload
            }

        case C.SET_REFERRAL_RESPONSE:
        	return {
                ...state,
                response: action.payload
            }

        case C.SEND_REFERRAL:
            return {
                ...state
            }

        default: return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/referralReducers.js